import { memo, useCallback, useEffect, useState } from "react";
import {
  AutoComplete,
  Button,
  DateInput,
  FormInput,
  Modal,
  useFormContext,
} from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { Grid, Stack, Typography } from "@mui/material";
import { listMainGenerics } from "../../../../../services/generic.service";
import { SalesContractPayerFinantialDisabled } from "../SalesContractPayerFinantialDisabled/SalesContractPayerFinantialDisabled";
import { useWatch } from "react-hook-form";
const translationPath =
  "page.4uSalesContract.registers.salesContractPayerFinantial.";
export const SalesContractPayerFinantial = memo(
  ({ payerId, finantialId }: { payerId: string; finantialId?: string }) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const closeModalHandler = () => setOpen(false);

    const openModalHandler = () => {
      setOpen(true);
    };

    const { control, setValue } = useFormContext();
    const enable = useWatch({
      name: "enable",
      control,
    });

    const onDisableFinantial = useCallback(async () => {
      setValue("idSalesContractPayerFinantial", null);
      setValue("bilingMethod", null);
      setValue("mail", null);
      setValue("phone", null);
      setValue("initialDate", null);
      setValue("endDate", null);
      setValue("monthlyPaymentDueDate", null);
      setValue("whatsappNumber", null);
      setValue("observation", null);
      setValue("enable", false);
    }, [setValue]);

    useEffect(() => {
      if (!payerId) {
        setValue("enable", true);
      }
      if (enable === false && finantialId) {
        onDisableFinantial();
      }
    }, [onDisableFinantial, setValue, payerId, finantialId, enable]);

    return (
      <>
        <Modal
          open={open}
          onClose={closeModalHandler}
          title={`${t(translationPath + "history")}`}
          maxDialogWidth="md"
        >
          {<SalesContractPayerFinantialDisabled payerId={payerId} />}
        </Modal>
        <Grid item xs={12} sm={6}>
          <Typography variant="h5">{`${t(
            translationPath + "financial"
          )}`}</Typography>
        </Grid>
        <Grid item xs={6} sm={6} textAlign="end">
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            {payerId && (
              <Button
                color="primary"
                variant="outlined"
                onClick={onDisableFinantial}
              >
                {t(translationPath + "new_finantial")}
              </Button>
            )}
            <Button
              color="primary"
              variant="contained"
              onClick={openModalHandler}
            >
              {t(translationPath + "history")}
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <AutoComplete
            getOptionLabel={({ name }) => name}
            size="small"
            label={t(translationPath + "biling_method")}
            name="bilingMethod"
            request={listMainGenerics}
            params={{
              Identifier: "SalesContractPayerFinantialsBillingMethod",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormInput
            size="small"
            name="mail"
            fullWidth
            label={t(translationPath + "mail") || "Mail"}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormInput
            name="phone"
            type="number"
            label={t(translationPath + "phone") || "Phone"}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormInput
            name="whatsappNumber"
            label={t(translationPath + "whatsapp_number") || "Whatsapp Number"}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DateInput
            name={"initialDate"}
            label={t(translationPath + "initial_date") || "Initial Date"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DateInput
            name={"endDate"}
            label={t(translationPath + "end_date") || "End Date"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInput
            size="small"
            type="number"
            name="monthlyPaymentDueDate"
            fullWidth
            label={
              t(translationPath + "monthly_payment_due_date") ||
              "Monthly Payment Due Date"
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormInput
            multiline
            name="observation"
            label={t(translationPath + "observation") || "Observation"}
            size="small"
            fullWidth
            minRows={4}
          />
        </Grid>
      </>
    );
  }
);
